module.exports = __webpack_public_path__ + "img/img-34.2d6c0300.png";